import { render, staticRenderFns } from "./Gdhk2.vue?vue&type=template&id=66d5dff7&scoped=true"
import script from "./Gdhk2.vue?vue&type=script&lang=js"
export * from "./Gdhk2.vue?vue&type=script&lang=js"
import style0 from "./Gdhk2.vue?vue&type=style&index=0&id=66d5dff7&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d5dff7",
  null
  
)

export default component.exports